export const appTitle = '';
export const userpoolName = 'userAccount';
